import { filterBundle } from './functions/filterBundle';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface DateneingabeEnergiedatenEigenstromProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

export interface DateneingabeEnergiedatenEigenstromState {
    jahr: number;
    monat: number;
}

export class DateneingabeEnergiedatenEigenstrom extends
    React.Component<DateneingabeEnergiedatenEigenstromProps, DateneingabeEnergiedatenEigenstromState> {

    constructor(props: any) {
        super(props);
        this.state = {
            jahr: null,
            monat: null
        };
        this.filterOptions = this.filterOptions.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    filterOptions?(options: Array<any>, key: string, data: any): Array<any> {
        const anlagen_eigenstrom: Array<any> = this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM] || [];
        const { standort_tid } = data;
        const anlagen_eigenstrom_typen: Array<any> = (this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN] || [])
            .filter((item: any) => (item.typ || null) === 'S')
            .map((item: any) => item.tid);
        const eigenstrom_typ: Array<number> = (standort_tid && +standort_tid > 0
            ? anlagen_eigenstrom
                .filter((item: any) => (item.standort_tid_orig || null) === standort_tid)
            : anlagen_eigenstrom)
                .filter((item: any) => anlagen_eigenstrom_typen.indexOf(item.anlagen_eigenstrom_typ_tid_orig || null) !== -1)
                .map((item: any) => item.anlagen_eigenstrom_typ_tid_orig)
                .filter(element => element !== undefined);

        switch (key) {
            case 'anlagen_eigenstrom_typ_tid':
                return (options && standort_tid && standort_tid > 0
                    ? options
                        .filter((item: any) => eigenstrom_typ.length === 0 || eigenstrom_typ.indexOf(item.tid || null) !== -1)
                    : options)
                        .filter((item: any) => (
                            anlagen_eigenstrom_typen.length === 0
                            || anlagen_eigenstrom_typen.indexOf(item.tid || null) !== -1)
                        );
            default:
                return options;
        }
    }

    onFormChange(WFormData: any): void {
        onFormChangeUniversal(IDs.ENT_ENERGIEDATEN_EIGENSTROM, WFormData, this);
    }

    preFilter(data: Array<any>): Array<any> {
        const { standortSelected } = this.props;

        return standortSelected
            ? data.filter((item: any) => (item.standort_tid_orig || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_ENERGIEDATEN_EIGENSTROM}
                module={IDs.MOD_ETOOL}
                actions={['add', 'edit', 'delete']}
                externalHeaderElements={[this.renderAuswertungButton()]}
                customClass='Custom-ETA'
                formLayout='flowV2'
                addLabel='Eigenstrom erfassen'
                bundleFilterFunc = {
                    (bundle: any) => (
                        filterBundle(IDs.ENT_ENERGIEDATEN_EIGENSTROM, bundle, this.props.data, this.props.standortSelected)
                    )
                }
                onFormChange={this.onFormChange}
                preFilterFunction={this.preFilter}
                valueFieldSelectDefaultOptions={{ monat: 'Ganzes Jahr' }}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_ENERGIEDATEN_EIGENSTROM)}
                filterOptions={this.filterOptions}
                validateField={this.validateField}
                globalData={this.props.data}
            />
        );
    }

    renderAuswertungButton(): JSX.Element {
        return (
            <WActionButton
                label='Auswertung'
                insideText='Auswertung'
                tooltip='Zum Datenauswertungsbereich springen'
                key='auswertung'
                action='view'
                onAction={() => this.props.onRoutingChange({ path: RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM })}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_ENERGIEDATEN_EIGENSTROM, key, value, data, onValueChange, this.props.data);
    }
}
